import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Title from 'components/typography/title'
import CSSModules from 'helpers/CSSModulesUtil'

import styles from './styles.scss' 

const ModuleHeaderContainer = props => (
  <div styleName='specHeader'>
    <Title>
      { props.children }
    </Title>
  </div>
)

ModuleHeaderContainer.propTypes = {
  children: PropTypes.node.isRequired,
}

export default CSSModules(styles, ModuleHeaderContainer)
